import { useState, useEffect } from 'react';
import { Video } from '../types';

export const useVideo = (initialVideo: Video | null = null) => {
  const [currentVideo, setCurrentVideo] = useState<Video | null>(initialVideo);
  const [nextVideo, setNextVideo] = useState<Video | null>(null);
  const [primaryVideoActive, setPrimaryVideoActive] = useState(true);
  const [isVideoFading, setIsVideoFading] = useState(false);
  
  // Save active video to localStorage when it changes
  useEffect(() => {
    const activeVideo = primaryVideoActive ? currentVideo : nextVideo;
    if (activeVideo) {
      localStorage.setItem('vibeCurrentVideo', activeVideo.id);
    }
  }, [currentVideo, nextVideo, primaryVideoActive]);

  // Switch to a specific background video
  const switchToVideo = (video: Video) => {
    if (isVideoFading) return;
    
    // Get the active video ID
    const activeVideoId = primaryVideoActive 
      ? currentVideo?.id 
      : nextVideo?.id;
    
    // If the selected video is already active, do nothing
    if (video.id === activeVideoId) return;
    
    // Start the transition
    if (primaryVideoActive) {
      setNextVideo(video);
    } else {
      setCurrentVideo(video);
    }
    
    // Start the fade transition
    setIsVideoFading(true);
    
    // After the fade is complete, swap which video is considered active
    setTimeout(() => {
      setPrimaryVideoActive(!primaryVideoActive);
      setIsVideoFading(false);
    }, 600); // 600ms transition
  };

  // Function to preload thumbnails
  const preloadThumbnails = (videos: Video[]) => {
    videos.forEach(video => {
      if (video.thumbnailUrl) {
        const img = new Image();
        img.src = video.thumbnailUrl;
      }
    });
  };

  return {
    currentVideo,
    setCurrentVideo,
    nextVideo,
    setNextVideo,
    primaryVideoActive,
    setPrimaryVideoActive,
    isVideoFading,
    switchToVideo,
    preloadThumbnails
  };
}; 